import styled from '@emotion/styled';
import { Accordion, AccordionDetails, AccordionSummary, Button, Stack, TextField, Typography } from '@mui/material';
import { useIliasDataCollection } from '@zs21/drv-bund-common-ilias-utils';
import $ from 'jquery';
import { withSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { ENV_VARS } from '../envVars';
import CustomRating from './CustomRating';
import { ExpandMore } from "@mui/icons-material";

const CssTextField = styled(TextField)({
	'& .MuiOutlinedInput-input': {
		'&::placeholder': {
			opacity: .75,
		},
	},
});

function FeedbackForm(props) {
	const [rating, setRating] = useState(null);
	const [feedback, setFeedback] = useState('');
	const { save } = useIliasDataCollection(JSON.parse(ENV_VARS['FEEDBACK_DATA_COLLECTION_CONFIG']));
	const onRatingChanged = (e, value) => {
		setRating(value);
	};
	const sendFeedback = () => {
		props.onProcessingStarted && props.onProcessingStarted();

		const permaLinkInput = $('#current_perma_link');
		const currentPage = permaLinkInput.length === 1 && permaLinkInput.val() ? permaLinkInput.val() : window.location.href;

		save({
			rating: rating,
			remark: feedback,
			context: '',
			featureFeedback: false,
			currentPage: currentPage,
		})
			.then(() => {
				props.enqueueSnackbar('Danke! Ihr Feedback hat uns erreicht.', { variant: 'success' });
				setRating(null);
				setFeedback('');
				props.onProcessingCompleted && props.onProcessingCompleted();
			})
			.catch((error) => {
				props.enqueueSnackbar('Hoppla, da ist etwas schiefgelaufen. Ihr Feedback hat uns leider nicht erreicht.', { variant: 'error' });
				props.onProcessingCompleted && props.onProcessingCompleted(error)
			});
	}

	return (
		<Stack spacing='1rem' direction='column'>
			<Stack alignItems='center' spacing={1} sx={{ mb: 2 }}>
				<CustomRating value={rating} onChange={onRatingChanged} color='primary' max={3} />
			</Stack>
			<CssTextField
				id='outlined-multiline-flexible'
				label='Ihr Feedback'
				InputLabelProps={{ shrink: true }}
				value={feedback}
				onChange={(evt) => {
					setFeedback(evt.target.value)
				}}
				multiline
				fullWidth
				variant='outlined'
				minRows={4}
				autoFocus
				placeholder='Bitte bewerten Sie hier nur die Lernwelt. Feedback zu Kursinhalten richten Sie bitte direkt an die inhaltlich Verantwortlichen.'
			/>
			<Typography sx={{ mt: '1rem' }} variant='body2' color='dimgray'>
				Sie geben Ihr Feedback nicht anonym ab und stimmen mit dem Absenden der Erfassung Ihres Benutzerkontos
				zu.
			</Typography>
			<Accordion sx={{ margin: 0, boxShadow: 0, '&:before': { backgroundColor: 'transparent' } }}>
				<AccordionSummary sx={{ margin: 0, padding: 0 }} expandIcon={<ExpandMore />}>
					<Typography variant='body2' color='dimgray'>Was bedeutet das?</Typography>
				</AccordionSummary>
				<AccordionDetails sx={{ '&.MuiAccordionDetails-root': { padding: '0.5rem 0' } }}>
					<Typography variant='body2' color='dimgray'>
						Sie geben Ihr Feedback als angemeldete*r Benutzer*in ab und willigen mit dem Absenden ein, dass
						Ihr
						Benutzerkonto erfasst wird. <br />
						Zu Ihrem Feedback werden demnach folgende Daten gespeichert: <br />
						• Ihr Vor- und Nachname <br />
						• Ihre E-Mail-Adresse <br />
						Zwecke der Datenerfassung: <br />
						• Möglichkeit für Rückfragen zum Feedback <br />
						• gewünschte Rückmeldungen geben <br />
						Ihre Einwilligung ist freiwillig. Es entstehen Ihnen keinerlei Nachteile, wenn Sie Ihre
						Einwilligung nicht erteilen möchten. Sie können Ihre erteilte Einwilligung jederzeit ganz oder
						teilweise mit Wirkung für die Zukunft widerrufen. Wenden Sie sich dafür an
						den <a
						href='mailto:mobiles-lernen@drv-bund.de?subject=ILIAS-Feedback%20–%20Widerruf%20Einwilligung'>Postkorb
						Mobiles Lernen (mobiles-lernen@drv-bund.de)</a>.
					</Typography>
				</AccordionDetails>
			</Accordion>
			<Button onClick={sendFeedback}
					disabled={rating === null}
					fullWidth
					variant='contained'
					color='primary'>Absenden</Button>
		</Stack>
	);
}

FeedbackForm.propTypes = {
	onProcessingStarted: PropTypes.func,
	onProcessingCompleted: PropTypes.func,
}

export default withSnackbar(FeedbackForm);
